module.exports = __webpack_public_path__ + "static/media/ZALOPAY.1172e331.svg";